import script from "./web-about.vue?vue&type=script&setup=true&lang=js"
export * from "./web-about.vue?vue&type=script&setup=true&lang=js"

import "./web-about.vue?vue&type=style&index=0&id=26f33a05&lang=scss"

const __exports__ = script;

export default __exports__